import { useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Form, message, Modal } from 'antd';

import { event } from '../event';
import {
  checkEmailService,
  sendCodeEmailByRegService,
  setZhiyinEmailBindService,
  unbindUser,
} from '../services';
import { getLocalZhiyinUser } from '../utils/index';
import FormBindEmail from './FormBindEmail';
import { useCountDownCustom } from './hooks';

import './index.less';

// 绑定手机号
const BindEmailApp = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  useState(() => event.on('event-showBindEmail', setIsModalOpen));

  const onCloseFormModal = () => {
    setIsModalOpen(false);
  };

  // ===========================  ===========================
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true); // 短信
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [form] = Form.useForm();

  const { codeBtnDisabled, btnContent, enable, setEnable, startCountDown } = useCountDownCustom();

  // 错误提示
  const showErrorInfo = (content?: any) => {
    message.error({
      content: content || '绑定邮箱失败',
      key: 'bindEmailError',
    });
  };

  // 校验邮箱
  const checkEmailBySubmit = async (value: any) => {
    const payload = { email: value };
    const result = await checkEmailService(payload);
    const status = result?.isExist ? true : false;
    if (status) {
      props?.bindEmailSuccess?.(false, '该邮箱已经被占用，请更换邮箱或联系商务');
      form.setFields([{ name: 'username', errors: ['该邮箱已经被占用，请更换邮箱或联系商务'] }]);
    }
    return status;
  };

  // 发送短信验证
  const onSendCode = async () => {
    try {
      const formValues = form.getFieldsValue();
      // 判断是邮箱还是手机号
      const username = formValues?.username;
      const status = await checkEmailBySubmit(username);
      if (status) {
        // 邮箱校验不通过
        return;
      }
      const payload = { email: username };
      // 邮箱存在不存在，走不通验证api
      // let data = status ? await sendCaptchaByEmail(payload) : await sendCodeEmailByRegService(payload);
      let data = await sendCodeEmailByRegService(payload);

      if (data?.error) {
        throw new Error(data?.msg);
      } else {
        // 开始倒计时
        startCountDown();
        setEnable(false);
        message.success('验证码发送成功，请查收!');
      }
    } catch (e) {
      if (e?.message === '60秒内不能发送多次验证码') {
        message.error(e?.message);
      } else {
        message.error('验证码发送失败，请稍候重试!');
      }
    }
  };

  const onFinish = async (values: any) => {
    const { username, code } = values;

    // 为 true 邮箱教育通过， 后端 api 有问题
    setLoadingBtn(true);
    const emailStatus = await checkEmailBySubmit(username);
    if (!emailStatus) {
      // 邮箱可以用
      const payload = {
        code,
        username,
        category: 3,
      };

      const result = await setZhiyinEmailBindService(payload);
      handleBindData(result, username); // 绑定数据处理
    }
    setLoadingBtn(false);
  };

  async function handleBindData(result: any, originName: string) {
    if (!result) {
      // 后端 api 异常统一提示
      props?.bindEmailSuccess?.(false, '服务端错误');
      showErrorInfo();
      return;
    }
    if (result?.resultDescription !== 'SUCCESS') {
      let errorText = result?.resultDescription || '绑定邮箱失败';
      showErrorInfo(errorText);
      props?.bindEmailSuccess?.(false, errorText);
      return;
    }

    // 先解绑邮箱
    const userInfo = getLocalZhiyinUser();
    const emails = userInfo?.aminer_emails?.filter(
      (email: string) => email && email !== originName,
    );
    try {
      if (emails?.length > 0) {
        const res = await Promise.all(
          emails.map((_item) => {
            return unbindUser({
              kind: 2, // 1: 2:邮箱 3:手机号
              kindValue: _item,
            });
          }),
        );
        if (res.some((item) => item.resultDescription !== 'SUCCESS')) {
          // 报错
          props?.bindEmailSuccess?.(false, '解绑失败');
          showErrorInfo('绑定失败，请稍后再试');
          setLoadingBtn(false);
          return;
        }
      }
    } catch (error) {
      // console.log(error);
    }

    message.success(`绑定邮箱成功`);
    // 添加定时器，防止页面刷新无提示
    setTimeout(() => {
      onCloseFormModal();
      props?.bindEmailSuccess?.(); // 修改成功回调
    }, 1000);
  }

  const handleFieldsChange = (fields: any, allFields: any) => {
    let isDisabledCheck = false;

    for (let fieldItem of allFields) {
      if (fieldItem.name[0] === 'username') {
        if (['请输入邮箱', '请输入正确的邮箱'].find((d) => fieldItem.errors?.includes(d))) {
          setEnable(false);
        } else {
          setEnable(true);
        }
      }
      if (fieldItem?.name[0] !== 'agreement') {
        // 不考虑协议
        if (fieldItem?.errors?.length > 0 || !fieldItem?.value) {
          //校验失败或者值为空
          isDisabledCheck = true;
          break;
        }
      }
    }
    setIsDisabledSubmit(isDisabledCheck);
  };

  const formProps = {
    form,
    onFinish,
    handleFieldsChange,
    onSendCode,
    isDisabledSubmit,
    loadingBtn,
    codeBtnDisabled,
    btnContent,
    enable,
  };

  return (
    <Modal
      maskClosable={false}
      width={props?.width || 480}
      destroyOnClose={true}
      centered={true}
      closable={false}
      open={isModalOpen}
      wrapClassName={'loginModalWrap'}
      footer={null}
      title={
        <div className={'loginHeader'}>
          <div>{/*<ArrowLeftOutlined className={'closeIcon'} />*/}</div>
          <div className={'closeIcon'} onClick={onCloseFormModal}>
            <CloseOutlined />
          </div>
        </div>
      }
    >
      <FormBindEmail {...props} {...formProps} />
    </Modal>
  );
};

export default BindEmailApp;
